import React, { memo } from 'react'
import { number, string } from 'prop-types'

export const Chevron = memo(
	({ color = '#FFA06A', height = '100%', width = '100%', strokeWidth = 2.1, rotationDeg = 0 }) => {
		return (
			<svg
				height={height}
				width={width}
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="0 0 22.5 11.4"
				style={{ enableBackground: 'new 0 0 22.5 11.4', transform: `rotate(${rotationDeg}deg)` }}
				xmlSpace="preserve"
			>
				<polyline
					fill="none"
					stroke={color}
					strokeWidth={strokeWidth}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit={10}
					points="21.4,10.4 11.2,1 1,10.4 "
				/>
			</svg>
		)
	}
)

Chevron.propTypes = {
	color: string,
	height: number,
	width: number,
	strokeWidth: number,
	rotationDeg: number,
}
